<template>
    <div style="padding:10px 20px">
        <span style="font-size:20px">网点服务</span>
        <p style="font-size:14px;color:#666666;text-align:left;"><span style="margin-left:20px"></span>加入专属网点，可以根据所属区域选择附近的日日顺服务网点。主要注册日日顺快线网点服务，经过身份验证，就可以抢单赚钱，海量订单，收入稳定，全职工作。</p>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>

</style>